<template>
  <div>
    <div class="i-head">
      <div class="i-imgbox">
        <div>
          <img class="i-img" src="../assets/image/hgbanner.png" />
        </div>
          
          <div>
            <el-button v-if="!loginuser.username"  class="btn-login" @click="dialogFormVisible = true">註冊/登錄</el-button>
            <div class="btn-login1" v-if="loginuser.username">
              <div class="userinfo">
                <el-avatar  icon="el-icon-user-solid"></el-avatar>
                <div @click="findmine" class="username">你好！<a href="#">{{ loginuser.username }}</a></div>
                <el-button   @click="loginout">退出</el-button>
              </div>
              
            </div>
            

            <el-dialog width="25%" title="用戶登錄" :visible.sync="dialogFormVisible">
              
              <el-form  :model="form">
                <el-form-item  label="*用戶名" :label-width="formLabelWidth">
                  <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>

                <el-form-item   label="*電話號碼" :label-width="formLabelWidth">
                  <el-input  v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="this.form.company=='zc'"  label="所在機構" :label-width="formLabelWidth">
                  <el-input  v-model="form.company" autocomplete="off"></el-input>
                </el-form-item>



                <el-form-item  label="*密碼" :label-width="formLabelWidth">
                  <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="this.form.yzword=='zc'"  label="*確認密碼" :label-width="formLabelWidth">
                  <el-input type="password" v-model="form.pwd" autocomplete="off"></el-input>
                </el-form-item>
                
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button v-if="this.form.yzword=='zc'" type="primary" @click="doregister()">註 冊</el-button>
                <el-button v-if="this.form.yzword=='dl'" type="primary" @click="dologin()">登 錄</el-button>
              </div>
              <div class="login-zc">
                <el-link v-if="this.form.yzword=='dl'"  @click="tozc"  >註冊</el-link>
                <el-link v-if="this.form.yzword=='zc'"  @click="todl" >登錄</el-link>
              </div>
              
            </el-dialog>
          </div>
      </div>
      
      <div class="i-title">
        
      
        <div class="tab-view">
          <!-- <router-link class="tab-a" :to="{name:'home'}">首页</router-link>
          <router-link class="tab-a" :to="{name:'dbList'}">数据库</router-link>
          <router-link class="tab-a" :to="{name:'booklist'}">电子书</router-link>
          <router-link class="tab-a" :to="{name:'journalList'}">辑刊</router-link>
          <router-link class="tab-a" :to="{name:'navigation'}">学术导航</router-link>
          <div class="tab-a" @click="tobtn" :to="{name:'booklist'}">新闻公告</div>
          <div class="tab-a"  @click="tobtn" :to="{name:'booklist'}">关于我们</div> -->
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item class="tab-a" index="1"  @click="tobtn(1)"
              ><div
                >首頁</div
              ></el-menu-item
            >
            <el-menu-item class="tab-a" index="2" @click="tobtn(2)"
              ><div >原書查詢</div></el-menu-item
            >
            <el-menu-item class="tab-a" index="3" @click="tobtn(3)"
              ><div >數據匯總</div></el-menu-item
            >
            <el-menu-item class="tab-a" index="4"  @click="tobtn(4)"
              ><div
                >內容檢索</div
              ></el-menu-item
            >
            <el-menu-item class="tab-a" index="5" @click="tobtn(5)"
              ><div  
                >海關研學</div
              ></el-menu-item
            >
            <el-menu-item class="tab-a" index="6" @click="tobtn(6)"
              ><div >
                研學論壇
              </div></el-menu-item
            >
            <el-menu-item class="tab-a" index="7" @click="tobtn(7)"
              ><div :to="{ name: 'booklist' }">
                子庫調用
              </div></el-menu-item
            >
            <el-menu-item class="tab-a" index="8" @click="tobtn(8)"
              ><div :to="{ name: 'booklist' }">
                研究工具
              </div></el-menu-item
            >
          </el-menu>
        </div>
        
      </div>
    </div>


    <div class="view">
      <router-view />
    </div>
    <div class="bottom">
      <div>
        網絡實名備案號：
        <a href="https://beian.miit.gov.cn">桂ICP备12003475号-8</a>
        新出網證（桂）字002號  公安機關備案號：4503020000033
      </div>
      <div>
        地址: 廣西壯族自治區桂林市七星區五裏店路9號 郵編541004
        業務電話：0773-2120735
      </div>
    </div>
  </div>
</template>
<script src="http://pv.sohu.com/cityjson?ie=utf-8"></script> 
<script>
import md5 from 'js-md5';
export default {
  name: "app",
  data() {
    return {
      activeIndex: 1,
      loginuser:{
          username: '',
          userid: '',
          hgcode:'',
        },
      username:"",
      password:"",
      //activeIndex2: "1",
      dialogTableVisible: false,
      dialogFormVisible: false,
        form: {
          name: '',
          phone:'',
          pho:'',
          password:'',
          pwd: '',
          yzword: 'dl',
          company:'',
        },
        formLabelWidth: '75px',
    };
  },
   created() {
    //this.activeIndex=this.$router.path;
    //console.log("当前目录："+this.activeIndex);
    //alert(returnCitySN["cip"]);
    //var ipobj=new ActiveXObject("rcbdyctl.setting");
    //alert(ipobj.getIPAddress);
    //这里是ip控制
    if(false){

          this.$http
        .post(`${this.$store.state.baseurl}/api/basetemp/Post`,this.hgcode)
        .then((res) => {

        })
      }


    this.loginuser.username=window.sessionStorage.getItem('hguser');
    this.loginuser.userid=window.sessionStorage.getItem('hguid');
    this.loginuser.code=window.sessionStorage.getItem('hgcode');
    //已登录
    if(this.loginuser.username!=""){

    }
    


  },

  methods: {
    //跳到注册
    tozc(){
      this.form.yzword="zc";
      //alert(this.form.yzword);s

    },
    //跳转到登录
    todl(){
      this.form.yzword="dl";
      //alert(this.form.yzword);

    },
    //个人中心
    findmine(){
      //activeIndex=1;
      this.$router.push({ path: "/hghome_mine" });

    },
    //退出登录
     loginout() {
        this.$confirm('您將退出用戶登錄, 是否繼續?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          window.sessionStorage.clear();
          this.loginuser.username="";
          this.loginuser.userid="";
          this.loginuser.code="";

          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          });          
        });
      },

      //注册
      doregister(){
        //let phonereg="/^1(3|4|5|6|7|8|9)\d{9}$/";
        //alert(phonereg.test(this.form.name));
        if(this.form.name.trim()==''){
          this.$message('用戶名不能為空！');
          return;
        }
        if(this.form.phone.length<8 || this.form.phone.length>14){
          this.$message('電話格式不正確！');
          return;
        }


        //alert(this.form.pwd);
        //alert(this.form.password);
        if(this.form.pwd.trim()==''){
          this.$message('密碼不能為空！');
          return;

        }
        if(this.form.password.length<6){
          this.$message('密碼必須6位數以上！');
          return;

        }

        if(this.form.pwd!=this.form.password){
          this.$message('兩次輸入的密碼不同');
          return;

        }
        //this.dialogFormVisible = false;
        this.form.pwd=md5(this.form.password);
        this.form.pho=md5(this.form.phone);
        //this.form.phone=md5(this.form.name);
        //this.form.phone=md5(this.form.name);
        //md5(this.form.name);
        this.form.phone="";
        this.form.password="";
        if(true){
          this.$http
        .post(`${this.$store.state.baseurl}/api/userregister/Post`,this.form)
        .then((res) => {
          
          const json = res.data;
          let uinfo=JSON.parse(json);
         // alert("开始zuce！");
          //注册成功
          if(uinfo.error=='0'){
            this.dologin.username=this.form.name;
            this.dialogFormVisible = false;
            this.$message('註冊成功！');
            this.form.yzword='dl';
            this.form.password="";
            this.form.pwd="";
            this.form.phone="";
            this.form.pho="";
            this.form.company="";
            alert('註冊成功');
            this.$router.go(0);
            

          }
          //注册失败if(uinfo.error=='1')
          else{
            //this.$message('註冊失敗，該用戶已註冊！');
            this.$message('註冊失敗，該用戶已註冊！');
            this.form.password="";
            this.form.pwd="";
            this.form.phone="";
            this.form.pho="";
            

          }


          
          //this.magzimelist=pinfo.data;
          //localStorage.setItem('hguser', 'Bearer ' + res.data);
        });

        }

      },
    
    //登录
    dologin(){
      
      if(this.form.name==''){
          this.$message('用戶名不能為空！');
          return;

        }

        if(this.form.password.length<6){
          this.$message('密碼必須6位數以上！');
          return;

        }


      //this.dialogFormVisible = false;
      //this.form.phone=md5(this.form.name);
      this.form.pwd=md5(this.form.password);
      this.form.password="";
      this.form.pho=md5(this.form.phone);
      this.form.phone="";
      if(true){
        this.$http
      .post(`${this.$store.state.baseurl}/api/userlogin/Post`,this.form)
      .then((res) => {
        
        const json = res.data;
        let uinfo=JSON.parse(json);
        //console.log("id为:"+json);
        //登录成功
        if(uinfo.error=='0'){
          this.loginuser.username=uinfo.data[0].Name;
          this.loginuser.userid=uinfo.data[0].ID;
          window.sessionStorage.setItem('hguser',uinfo.data[0].Name);
          window.sessionStorage.setItem('hguid',uinfo.data[0].ID);
          window.sessionStorage.setItem('hgcode',uinfo.data[0].code);
          this.$message('登錄成功！');
          this.$router.go(0);

        }
        //登录失败(uinfo.error=='1')
        else{
          this.$message('登錄失敗！');
          this.$router.go(0);

        }
        
        //this.magzimelist=pinfo.data;
        //localStorage.setItem('hguser', 'Bearer ' + res.data);
      });

      }
    },
    
    tobtn(nber) {
      //this.activeIndex=nber;
      
      switch (nber) {
        case 1:
          this.$router.push({ path: "/hghome" });
          break;
        case 2:
          this.$router.push({ path: "/hgbookread" });
          break;
        case 3:
          this.$router.push({ path: "/hgdatacount" });
          break;
        case 4:
          this.$router.push({ path: "/hgsearch" });
          break;
        case 5:
          //this.$router.push({ path: "/hgresearch" });
          this.$message('研學功能暫未開放！');
          break;
        case 6:
          //this.$router.push({path: "/hgtalk"});
          this.$message('論壇功能暫未開放！');
          break;
        case 7:
          //this.$router.push({path: "/hgsub"});
          this.$message('子庫功能暫未開放！');
          break;
        case 8:
        this.$message('子庫功能暫未開放！');
          //this.$router.push({path: "/hgtool"});
          //alert('');
          break;
      }
      //this.activeIndex=nber;
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      //this.activeIndex=keyPath;
    },
  },
  
};
</script>

<style  lang="scss">
.i-head {
  background-color: #f7f6f4;
  height: 128px;
  
  .i-imgbox{
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    text-align: left;
    width: 1440px;
    margin-left: auto;
    margin-right: auto;
    

  }
  .i-img{
    height: 65px;
    margin-top: 10px;
    margin-left: 100px;
  }
  .i-title {
    display: flex;
    width: 1440px;
    margin: 0 auto;
  }
  .userinfo{
    display: flex;
    .username{
      padding-top: 10px;
      padding-left: 10px;
    }
  }
  .btn-login1 {
    text-align: right;
    margin-left: 550px;
    margin-top: 36px;
    font-size: 14px;
    color: #987154;
    text-decoration: none;
    button{
      margin-left: 10px;
      border-color: #987154;
      background-color: #f7f6f4;
      color:#987154;
      width: 70px;
      height: 36px;
      border-radius: 5px;
    }
  }
  .btn-login {
    margin-left: 730px;
    margin-top: 36px;
    font-size: 14px;
    color: #987154;
    text-decoration: none;
    button{
      border-color: #987154;
      background-color: #f7f6f4;
      color:#987154;
      width: 120px;
      height: 36px;
      border-radius: 5px;
    }
  }
  .tab-view {
    margin-left: 350px;
    color: #ffffff;
    line-height: 45px;
    margin-top: 0px;
    display: flex;
    flex-direction: row;
    .tab-a {
      color: #403f3d;
      font-size: 18px;
      width: 120px;
      height: 50px;
      text-decoration: none;
    }
    // .tab-a:hover {
    //   color: red;
    // }
  }
}

.bottom {
  height: 104px;
  background-color:#e5e2db;
  width: 100%;
  line-height: 40px;
  padding-top: 20px;
  color:#8f6442;
  div {
    margin: 0 auto;
    width: 1440px;
    text-align: center;
    font-size: 12px;
  }
  a {
    text-decoration: none;
    color:#c5b6a9;
  }
}
.el-menu {
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background: none !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #c60828 !important;
    color: #303133;
}

.el-menu-item:hover {
  background-color: #00ff00;
}

.el-menu-item.tab-a:hover {
  background: none !important;
   color: #e35364 !important;
}
.el-menu-item.is-active:hover {
  background: none !important;
   color: #e35364 !important;
}
.el-menu-item.is-active {
  color: #e35364 !important;
  background: none !important;
}
.el-dialog__body{
padding-bottom: 0px;
}
.dialog-footer{
  text-align: center;
}
.login-zc{
  text-align: right;
}
</style>
